import React from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Outlet, useLocation } from "react-router-dom";

const DashboardLayout = () => {
  const location = useLocation();
  const isWhatsApp = location.pathname.includes("/whatsapp");

  const styles = {
    layout: {
      display: "flex",
      height: "100vh",
      overflow: "hidden",
      backgroundColor: "#f4f6f9",
    },
    mainContent: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    outletWrapper: {
      flexGrow: 1,
      overflowY: isWhatsApp ? "hidden" : "auto",
      padding: isWhatsApp ? "16px" : "20px",
      display: "flex",
      flexDirection: "column",
    },
  };

  return (
    <div style={styles.layout}>
      <Sidebar />
      <div style={styles.mainContent}>
        <Topbar />
        <div style={styles.outletWrapper}>
          <Outlet /> {/* Nested routes render here */}
        </div>
      </div>
    </div>
  );
};
export default DashboardLayout;